var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyncDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22,8l-4-4v3H3v2h15v3L22,8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2,16l4,4v-3h15v-2H6v-3L2,16z"
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    x1: 16.5,
    y1: 1.8,
    x2: 7.6,
    y2: 22.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncDisabled);
export default __webpack_public_path__ + "static/media/sync-disabled.e4c5a1f3.svg";
export { ForwardRef as ReactComponent };